export const isMobile = () => {
  return document.body.offsetWidth <= 928;
};

export const isDesktop = () => {
  return document.body.offsetWidth > 928;
};

export const isTouchDevice = () => {
  return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));
}
